const GUEST_TOKEN_KEY = 'edi_guest_token';

const createToken = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}-${Math.random().toString(16).slice(2)}`;
};

export const getGuestToken = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  let token = localStorage.getItem(GUEST_TOKEN_KEY);
  if (!token) {
    token = createToken();
    localStorage.setItem(GUEST_TOKEN_KEY, token);
  }
  return token;
};

export const clearGuestToken = () => {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.removeItem(GUEST_TOKEN_KEY);
};
